import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CookieSettings } from '../components/CookieSettings';
export function DatenschutzPage() {
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleCookieSave = (preferences: {
    necessary: boolean;
    analytics: boolean;
    marketing: boolean;
  }) => {
    const prefs = {
      ...preferences,
      timestamp: Date.now()
    };
    localStorage.setItem('vitafrukt-cookie-consent', JSON.stringify(prefs));
    setShowCookieSettings(false);
  };
  return <>
      <section className="py-16 md:py-24 bg-white" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-325">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-vita-green-deep mb-12" data-id="element-326">
            Datenschutzerklärung
          </h1>

          <div className="space-y-10 text-vita-text-muted leading-relaxed" data-id="element-327">
            <div data-id="element-328">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-329">
                1. Verantwortliche Stelle
              </h2>
              <p data-id="element-330">
                Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="mt-2" data-id="element-331">
                Nuviora UG (haftungsbeschränkt) Cosimastraße 121 München, 81925
                Deutschland E-Mail: info@vitafrukt.de
              </p>
            </div>

            <div data-id="element-332">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-333">
                2. Erhebung und Speicherung personenbezogener Daten
              </h2>
              <p data-id="element-334">
                Beim Besuch unserer Website werden automatisch Informationen
                durch den Browser übermittelt und in sogenannten
                Server-Log-Dateien gespeichert. Dies umfasst Browsertyp und
                -version, verwendetes Betriebssystem, Referrer URL, Hostname des
                zugreifenden Rechners, Uhrzeit der Serveranfrage und die
                IP-Adresse.
              </p>
              <p className="mt-3" data-id="element-335">
                Diese Daten sind nicht bestimmten Personen zuordenbar. Eine
                Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
                vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu
                prüfen, wenn uns konkrete Anhaltspunkte für eine rechtswidrige
                Nutzung bekannt werden.
              </p>
            </div>

            <div data-id="element-336">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-337">
                3. Cookies
              </h2>
              <p data-id="element-338">
                Unsere Website verwendet Cookies. Cookies sind kleine
                Textdateien, die auf deinem Endgerät gespeichert werden und die
                dein Browser speichert. Sie dienen dazu, unser Angebot
                nutzerfreundlicher und effektiver zu machen.
              </p>
              <p className="mt-3" data-id="element-339">
                Wir unterscheiden zwischen notwendigen Cookies, die für die
                Grundfunktionen der Website erforderlich sind, Analyse-Cookies,
                die uns helfen, die Nutzung der Website zu verstehen, und
                Marketing-Cookies.
              </p>
              <p className="mt-3" data-id="element-340">
                Du kannst deine Cookie-Einstellungen jederzeit anpassen:
              </p>
              <button onClick={() => setShowCookieSettings(true)} className="mt-3 inline-flex items-center px-5 py-2.5 bg-vita-green-deep text-white font-medium rounded-full hover:bg-vita-green-medium transition-colors text-sm" data-id="element-341">
                Cookie-Einstellungen öffnen
              </button>
            </div>

            <div data-id="element-342">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-343">
                4. Analyse-Tools
              </h2>
              <p data-id="element-344">
                Wir nutzen ggf. Analyse-Tools, um das Nutzungsverhalten auf
                unserer Website statistisch auszuwerten. Die dabei gewonnenen
                Daten werden nicht dazu verwendet, den Besucher dieser Website
                persönlich zu identifizieren, und werden nicht mit
                personenbezogenen Daten zusammengeführt. Die Nutzung dieser
                Tools erfolgt nur mit deiner Einwilligung.
              </p>
            </div>

            <div data-id="element-345">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-346">
                5. Newsletter
              </h2>
              <p data-id="element-347">
                Wenn du unseren Newsletter abonnierst, wird deine E-Mail-Adresse
                für den Versand des Newsletters gespeichert. Du kannst den
                Newsletter jederzeit über den Abmeldelink in jeder E-Mail oder
                per Nachricht an uns abbestellen. Nach der Abmeldung wird deine
                E-Mail-Adresse gelöscht.
              </p>
            </div>

            <div data-id="element-348">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-349">
                6. Deine Rechte
              </h2>
              <p data-id="element-350">Du hast jederzeit das Recht auf:</p>
              <ul className="mt-3 space-y-2 ml-4" data-id="element-351">
                <li className="flex items-start" data-id="element-352">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-353"></span>
                  <span data-id="element-354">
                    <span className="font-medium text-vita-text" data-id="element-355">Auskunft</span>{' '}
                    über deine bei uns gespeicherten personenbezogenen Daten
                  </span>
                </li>
                <li className="flex items-start" data-id="element-356">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-357"></span>
                  <span data-id="element-358">
                    <span className="font-medium text-vita-text" data-id="element-359">
                      Berichtigung
                    </span>{' '}
                    unrichtiger personenbezogener Daten
                  </span>
                </li>
                <li className="flex items-start" data-id="element-360">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-361"></span>
                  <span data-id="element-362">
                    <span className="font-medium text-vita-text" data-id="element-363">Löschung</span>{' '}
                    deiner bei uns gespeicherten Daten
                  </span>
                </li>
                <li className="flex items-start" data-id="element-364">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-365"></span>
                  <span data-id="element-366">
                    <span className="font-medium text-vita-text" data-id="element-367">
                      Einschränkung
                    </span>{' '}
                    der Datenverarbeitung
                  </span>
                </li>
                <li className="flex items-start" data-id="element-368">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-369"></span>
                  <span data-id="element-370">
                    <span className="font-medium text-vita-text" data-id="element-371">
                      Widerspruch
                    </span>{' '}
                    gegen die Verarbeitung deiner Daten
                  </span>
                </li>
                <li className="flex items-start" data-id="element-372">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-373"></span>
                  <span data-id="element-374">
                    <span className="font-medium text-vita-text" data-id="element-375">
                      Datenübertragbarkeit
                    </span>{' '}
                    in einem gängigen Format
                  </span>
                </li>
              </ul>
            </div>

            <div data-id="element-376">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-377">
                7. Kontakt für Datenschutzanfragen
              </h2>
              <p data-id="element-378">
                Bei Fragen zum Datenschutz kannst du dich jederzeit an uns
                wenden:
              </p>
              <p className="mt-2" data-id="element-379">
                E-Mail: info@vitafrukt.de Nuviora UG (haftungsbeschränkt)
                Cosimastraße 121 München, 81925 Deutschland
              </p>
            </div>

            <div className="pt-6 border-t border-vita-border text-sm text-vita-text-light" data-id="element-380">
              <p data-id="element-381"></p>
            </div>
          </div>
        </motion.div>
      </section>

      <CookieSettings isOpen={showCookieSettings} onClose={() => setShowCookieSettings(false)} onSave={handleCookieSave} data-id="element-382" />
    </>;
}